import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6b9a610a&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=6b9a610a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a610a",
  null
  
)

export default component.exports